import React from 'react'
import { Dialog, DialogContent } from '@material-ui/core'
import ReactPlayer from 'react-player'

import { useStyles } from 'styles/styles'

interface VideoPlayerProps {
    open: boolean
    videoUrl: string
    onDialogClose: () => void
}

const VideoPlayerDialog: React.FC<VideoPlayerProps> = (props) => {
    const classes = useStyles()

    const handleDialogClose = () => {
        props.onDialogClose()
    }

    return (
        <Dialog
            maxWidth='lg'
            open={props.open}
            onClose={handleDialogClose}
            aria-labelledby="max-width-dialog-title"
            classes={{paper: classes.videoDialog}}
        >
            <DialogContent className={classes.videoContent}>
                <ReactPlayer className={classes.videoPlayer} url={props.videoUrl} controls playing pip />
            </DialogContent>
        </Dialog>
    )
}

export default VideoPlayerDialog
